import type React from 'react';
import Icon3DGlasses from 'images/icons/3d-glasses.svg';
import Text from 'app/shared/core/Text';
import {
  tour3dButton3dTextStyles,
  tour3dButtonIconStyles,
  tour3dButtonStyles,
  tour3dButtonTourTextStyles,
} from './Tour3dButton.styles';

const Tour3dButton: React.FC = () => {
  return (
    <div className={tour3dButtonStyles}>
      <img src={Icon3DGlasses} className={tour3dButtonIconStyles} alt="3D Glasses Icon" />
      <Text className={tour3dButton3dTextStyles}>3D</Text>
      <Text className={tour3dButtonTourTextStyles}>3D tour</Text>
    </div>
  );
};

export default Tour3dButton;
